import Color from 'color'

export const darkenColor = (color, amt) =>
  Color(color)
    .darken(amt)
    .hex()

export const fadeColor = (color, amt) =>
  Color(color, 'hex')
    .fade(amt)
    .array()
    .toString()

export const DEFAULT_SURFACE_CURVATURE = '10px'
